import {MDIcon} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {Project} from '@mintdata-wsp/common/state/DataState';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {DataSource, IListItemState} from '@mintdata/mint-kit/api/models/List';
import {ContextMenu, IContextMenuItem, ToggleOn} from '@mintdata/mint-kit/impl/components/contextMenu/ContextMenu';
import {PopupAnchor, SourceAnchor} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import {IStyles} from '@mintdata/mint-kit/impl/util/Styles';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./SpaceDotsMenu.less');
const cx = classnames.bind(styles);

interface Props
{
    className:string;
    project:Project;
}

interface State
{
    isOpened:boolean;
}

interface ISpaceDotsMenuItem extends IContextMenuItem
{
    action?:() => void
}

@observer
export class SpaceDotsMenu extends React.Component<Props, State>
{
    public constructor(props:any)
    {
        super(props);

        this.state = {
            isOpened: false
        };
    }

    private _menuItems:Array<ISpaceDotsMenuItem> = this._computeMenu();

    @bind
    private _computeMenu():Array<ISpaceDotsMenuItem>
    {
        return [
            {
                label: 'Rename',
                action: this._menuItemRenameSpace
            },
            {
                isSeparator: true
            },
            {
                label: 'Delete',
                action: this._menuItemDeleteSpace
            },
        ];
    }

    private _onShow = () => this.setState({isOpened: true});
    private _onHide = () => this.setState({isOpened: false});

    @bind
    private _menuItemRenameSpace()
    {
        const {project} = this.props;

        controllers.data.projects.renameProjectDialog(project);
    }

    @bind
    private _menuItemDeleteSpace()
    {
        const {project} = this.props;
        let {currentProject} = rootState.ui.mainPage;

        controllers.data.projects.deleteSpaceDialog(project).then(() =>
        {
            controllers.ui.dialogs.hideConfirmDialog();

            if( currentProject && project.id === currentProject.id )
                controllers.navigation.toAppHome();
        });
    }

    private _selectMenuItem = (item:ISpaceDotsMenuItem) =>
    {
        item.action && item.action();
    };

    private _menuProvider = ():DataSource<ISpaceDotsMenuItem> =>
    {
        return this._menuItems.map((menuItem:ISpaceDotsMenuItem) =>
        {
            if( menuItem.isSeparator ) return menuItem;

            return {
                ...menuItem,
                handler: this._selectMenuItem,
            } as ISpaceDotsMenuItem;
        });
    };

    @bind
    private _renderMenuItem({label, isSeparator}:ISpaceDotsMenuItem,
                            {}:IListItemState,
                            {menuItem, separator}:IStyles):JSX.Element | null
    {
        if( isSeparator ) return (
            <div className={cx(separator)} />
        );

        return (
            <div className={cx(styles.menuItem, menuItem)}>

                <div className={styles.menuItemLabel}>
                    {label}
                </div>

            </div>
        );
    }

    public render():JSX.Element
    {
        const togglerId = 'SpaceDotsMenu';

        const {className} = this.props;

        const {isOpened} = this.state;

        return (
            <div className={cx(styles.base, className, {isOpened})} id={togglerId}>
                <ContextMenu
                    className={cx(styles.contextMenu)}
                    popupClassName={styles.menuPopup}
                    contentClassName={styles.popupContent}
                    toggleOn={[ToggleOn.CLICK]}
                    togglersIds={[togglerId]}
                    popupAnchor={PopupAnchor.RightTop}
                    sourceAnchor={SourceAnchor.RightBottom}
                    dataSource={this._menuProvider}
                    itemRenderer={this._renderMenuItem}
                    onShow={this._onShow}
                    onHide={this._onHide}
                >
                    <MDIcon
                        className={cx(styles.iconDots)}
                        name={MDIcons.common.ThreeDotsVert}
                    />
                </ContextMenu>
            </div>
        );
    }
}
